import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-word",
  "use": "icon-ic-word-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic-word\">\r\n    <path d=\"M51.2 0h793.6a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H179.2a128 128 0 0 1-128-128V0z\" fill=\"#809DFC\" p-id=\"3840\" />\r\n    <path d=\"M686.9248 716.8h-75.9808L524.8 452.7872 438.656 716.8h-75.9808L281.6 332.8h70.912l55.7568 268.8 86.1184-259.2h60.8L636.288 601.6 697.088 332.8H768l-81.0752 384z\" fill=\"#FFFFFF\" p-id=\"3841\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol